import ApiClient from '@/helpers/api/api.helpers';

class agentAvailability extends ApiClient {
  constructor() {
    super('reports/metrics/agent');
  }
}

export default new agentAvailability();
